module.exports = __webpack_public_path__ + "img/LOTTE_FINANCE.0c4fb16f.svg";